import React from "react";
import PageHeader from "../components/page-header";
import TravelTechnologyClip from "../assets/images/solutions/travel-technology-clip.png";
import TraveltechApplications from "../assets/images/solutions/traveltech-applications.png";
import Img1 from "../assets/images/solutions/enterprise-software/enterprise-ota.png";
import Img2 from "../assets/images/solutions/enterprise-software/tdx.png";
import Img3 from "../assets/images/solutions/enterprise-software/edp-diagram.png";
import Img4 from "../assets/images/solutions/enterprise-software/umrah-solution.png";
import Img5 from "../assets/images/solutions/enterprise-software/host-agency-workflow.png";
import SaasModel from "../assets/images/solutions/enterprise-software/saas-model.png";

import { Link } from "react-router-dom";
import HomeSolutions from "../components/home-solutions";

const SolutionsEnterpriseSoftware = () => {
  return (
    <div className="page-inside page-booking-engine">
      <PageHeader page="enterprise-software" />
      <div className="container">
        <div className="row">
          <h2 className="text-center">
            Enterprise Travel Technology for Systems That Cannot Simply Be
            Replaced
          </h2>
          <div className="col-lg-6 text-center">
            <img
              src={TravelTechnologyClip}
              alt="Travel Technology"
              className="w-100"
              style={{ maxWidth: "412px" }}
            />
          </div>
          <div className="col-lg-6 text-justify">
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              Large and established travel companies often run on complex
              systems: booking engines, B2B/B2C portals, Travel CRM, supplier
              integrations, back-office systems, accounting and reconciliation
              workflows, reporting, and operational tools built over many years.
              TravelCarma helps AI-enable, manage, maintain, modernize, and
              extend these enterprise travel systems without forcing a
              disruptive rip-and-replace approach.
            </p>

            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              Our work is grounded in 20+ years of building travel technology
              products and platforms. We understand the architecture behind
              supplier/API connectivity, booking workflows, distribution,
              itinerary and quotation systems, back-office automation, and
              enterprise travel infrastructure.
            </p>
          </div>
          <div className="col-lg-12 mt-4">
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              Enterprise travel technology forms the backbone of large travel
              companies, OTAs, wholesalers, DMCs, TMCs, host agencies, and
              multi-branch travel businesses. It connects reservations,
              distribution, supplier content, customer management, pricing,
              accounting, reporting, and service workflows into the systems that
              keep operations moving.
            </p>
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              For established travel businesses, modernization must be practical.
              We help improve existing travel technology solutions in controlled
              phases, adding AI-enabled workflows, supplier/API normalization,
              custom modules, and dedicated engineering execution where they
              create measurable value.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <h2 className="text-center">
            Enterprise Travel Workflows We Help Modernize
          </h2>
          <div className="col-lg-6 text-justify">
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              Travel technology now touches every part of enterprise travel
              operations: search, booking, distribution, supplier content,
              pricing, customer management, quotation workflows, reporting,
              accounting, reconciliation, and agent or partner networks. We help
              identify where AI, automation, integration, and custom engineering
              can improve these workflows while protecting systems that already
              work.
            </p>
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              <strong>TravelCarma</strong> has deep knowledge and expertise in
              enterprise travel technology, working with several players within
              the global travel industry value chain. TravelCarma provides{" "}
              <strong>travel technology solutions</strong> and hands-on{" "}
              <Link
                to="/solutions/travel-tech-consulting"
                className="text-decoration-none text-primary"
              >
                travel technology consulting
              </Link>{" "}
              for companies that need to AI-enable, manage, extend, or rebuild
              enterprise travel systems around their real operating model.
            </p>
            <Link to="/contact-us" className="btn btn-primary">
              Discuss Your Enterprise Technology Challenge
            </Link>
          </div>
          <div className="col-lg-6 text-center">
            <img
              src={TraveltechApplications}
              alt="Travel Technology Application"
              className="w-100"
              style={{ maxWidth: "412px" }}
            />
          </div>
        </div>
      </div>
      <div
        className="mt-5 pt-5 pb-5"
        style={{
          background:
            "linear-gradient(to bottom, rgba(229,229,229,0.5) 0%,rgba(255,255,255,0.5) 51%,rgba(229,229,229,0.5) 100%)",
        }}
      >
        <div className="container">
          <h2 className="text-center">
            Enterprise Travel Technology Capabilities Built From Real Platform
            Experience
          </h2>
          <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
            TravelCarma's existing products, modules, and platforms are proof of
            experience. Today, we use that experience to help enterprise travel
            companies modernize legacy systems, layer AI into workflows,
            integrate and normalize supplier/API data, deploy dedicated travel
            technology engineering teams, and build bespoke platforms when
            standard software cannot fit.
          </p>
          <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
            Our microservices-based and service-oriented architecture experience
            allows us to connect with existing enterprise systems, including
            CRM, accounting, supplier platforms, reporting tools, and
            customer-facing portals. This supports phased modernization, custom
            module development, and integration-ready enterprise travel systems.
          </p>
          <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
            These capabilities support enterprise travel software needs across
            booking engines, B2B/B2C portals, Travel ERP, supplier/API
            integration, Travel CRM, back-office systems, accounting,
            reconciliation, reporting, travel automation, and bespoke enterprise
            workflows.
          </p>
          <div className="text-center">
            <Link to="/contact-us" className="btn btn-primary">
              Modernize Your Travel Platform
            </Link>
          </div>
          <HomeSolutions />

          <div className="row mt-5">
            <div
              className="col-lg-6 p-4"
              style={{
                borderTop: "solid 2px #5089b6",
                borderLeft: "solid 2px #5089b6",
              }}
            >
              <img src={Img1} alt="Enterprise OTA" className="w-100" />
            </div>
            <div
              className="col-lg-6 text-center text-white p-4"
              style={{ background: "#5089b6" }}
            >
              <h3
                style={{ fontSize: "2.0rem", fontWeight: "600" }}
                className="mb-4"
              >
                Travel ERP
              </h3>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                TravelCarma Enterprise reflects our experience in reservation,
                CRM, accounting, back-office, reporting, and enterprise workflow
                systems for large travel operations. Its modular and
                service-oriented foundation shows how enterprise travel software
                can be customized, integrated with existing IT systems, and
                extended around complex operating needs.
              </p>
              <Link
                to="/solutions/travel-agency-software"
                className="btn btn-primary"
              >
                Read More
              </Link>
            </div>

            <div
              className="col-lg-6 text-center text-white p-4"
              style={{ background: "#380085" }}
            >
              <h3
                style={{ fontSize: "2.0rem", fontWeight: "600" }}
                className="mb-4"
              >
                Travel Aggregation
              </h3>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                TravelCarma TDX demonstrates our supplier/API aggregation,
                normalization, unified API, and travel data orchestration
                capability. This experience helps enterprise travel companies
                connect multiple suppliers, standardize content, and make live
                inventory usable across booking, reporting, pricing, and
                automation workflows.
              </p>
              <Link
                to="/solutions/travel-data-xchange-switch"
                className="btn btn-primary"
              >
                Read More
              </Link>
            </div>
            <div
              className="col-lg-6 p-4 text-center"
              style={{
                borderRight: "solid 2px #380085",
              }}
            >
              <img
                src={Img2}
                alt="Travel Content Aggregation"
                className="w-100"
                style={{ maxWidth: "420px" }}
              />
            </div>

            <div
              className="col-lg-6 p-4"
              style={{
                borderLeft: "solid 2px #26deb8",
              }}
            >
              <img
                src={Img3}
                alt="EDP Diagram V3 TravelCarma"
                className="w-100"
              />
            </div>
            <div
              className="col-lg-6 text-center text-white p-4"
              style={{ background: "#26deb8" }}
            >
              <h3
                style={{ fontSize: "2.0rem", fontWeight: "600" }}
                className="mb-4"
              >
                E-IMDP(Inventory Distribution Solution)
              </h3>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                E-IMDP reflects TravelCarma's experience with inventory, channel
                management, contracted product distribution, pricing, reseller
                workflows, and unified API delivery. These capabilities are
                useful for enterprise travel companies managing supplier
                content, agent networks, and multi-channel distribution.
              </p>
              <Link
                to="/solutions/inventory-distribution"
                className="btn btn-primary"
              >
                Read More
              </Link>
            </div>

            <div
              className="col-lg-6 text-center text-white p-4"
              style={{ background: "#234937" }}
            >
              <h3
                style={{ fontSize: "2.0rem", fontWeight: "600" }}
                className="mb-4"
              >
                Hajj and Umrah Booking Solution
              </h3>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                TravelCarma Hajj & Umrah Booking Solution (HUBS) is proof of
                our ability to support specialized, regulated, and
                high-complexity travel workflows. It connects agencies,
                operators, packages, flights, hotels, ground services, and GDS
                connectivity into structured booking journeys.
              </p>
              <Link
                to="/solutions/hajj-umrah-booking-solution"
                className="btn btn-primary"
              >
                Read More
              </Link>
            </div>
            <div
              className="col-lg-6 p-4"
              style={{
                borderRight: "solid 2px #234937",
              }}
            >
              <img
                src={Img4}
                alt="Hajj Umrah Solution Overview"
                className="w-100"
              />
            </div>

            <div
              className="col-lg-6 p-4"
              style={{
                borderLeft: "solid 2px #d72c4a",
                borderBottom: "solid 2px #d72c4a",
              }}
            >
              <img src={Img5} alt="Host Agency Workflow" className="w-100" />
            </div>
            <div
              className="col-lg-6 text-center text-white p-4"
              style={{ background: "#d72c4a" }}
            >
              <h3
                style={{ fontSize: "2.0rem", fontWeight: "600" }}
                className="mb-4"
              >
                Symbion (Host Agency Solution)
              </h3>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                Symbion reflects our host agency, large network, B2B2C workflow,
                and multi-agent distribution capability. It shows how
                enterprise travel platforms can support agent networks,
                inventory access, branded portals, operational control, and
                revenue optimization across distributed businesses.
              </p>
              <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                For host agencies working with thousands of sub-agents or
                affiliates across a region, TravelCarma's experience helps
                manage inventory distribution, partner access, booking workflows,
                and commercial rules at enterprise scale.
              </p>
              <Link
                to="/solutions/host-agency-solution"
                className="btn btn-primary"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <h2 className="text-center mt-5 mb-5">Our Strengths</h2>
        <p className="text-center">
          These strengths come from building and operating real travel
          technology platforms. They now support AI-first modernization, managed
          system extension, supplier/API integration, dedicated engineering
          execution, and bespoke enterprise platform builds.
        </p>

        <ul class="shadow-box list-unstyled row">
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">Enterprise Workflow Depth</h3>
              <p>
                TravelCarma has built booking, payment, search, multi-product
                cart, social planning, B2B/B2C, and mobile travel workflows.
                This experience helps us design enterprise systems around real
                travel operations rather than generic software patterns.
              </p>
            </div>
          </li>
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">Modular Enterprise Architecture</h3>
              <p>
                Scalable services-based architecture, modular components,
                service/API access, business rules, custom UX, multi-product
                aggregation, multilingual and multicurrency functions, and
                marketplace features are part of our enterprise technology
                foundation.
              </p>
            </div>
          </li>
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">
                B2B/B2C and Partner Network Experience
              </h3>
              <p>
                TravelCarma's B2B2C experience helps large agents, host
                agencies, and wholesalers provide branded portals, CRS access,
                contracted inventory, reseller workflows, and commercial controls
                to downline agents and partners.
              </p>
            </div>
          </li>
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">
                Supplier/API Integration and Normalization
              </h3>
              <p>
                With connections to more than 80+ suppliers, we bring extensive
                experience in supplier/API integration, content aggregation,
                normalization, display, booking workflows, and supplier
                coordination across enterprise travel operations.
              </p>
            </div>
          </li>
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">
                Global Travel Technology Credibility
              </h3>
              <p>
                With more than 200 portals, clients in over 60 countries,
                integrations with 80+ suppliers, industry-first solutions, and
                awards from leading industry authorities, TravelCarma is a
                trusted travel technology company.
              </p>
            </div>
          </li>
          <li className="col-lg-4 mb-3">
            <div className="text-center">
              <h3 className="text-primary">Travel Operations Automation</h3>
              <p>
                Quotation management, price checking, reusable quotes and
                itineraries, back-office and mid-office management, reports, CRM
                hooks, accounting integrations, and workflow automation are
                enterprise capabilities we can modernize and AI-enable.
              </p>
            </div>
          </li>
        </ul>

        <div className="solutions-section">
          <div className="row">
            <div className="col-lg-4">
              <ul className="mt-0">
                <li>
                  Multi-level aggregation and distribution for different travel
                  products, with 80+ suppliers on the same system and
                  high-volume API handling that can support thousands of
                  simultaneous requests. We have been recognized as a Top
                  Innovator from Nasscom for this capability
                </li>
                <li>
                  Product ID based access to travel products supports controlled
                  supplier orchestration, custom booking flows, and one-click
                  access to buying from third-party sites
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <ul className="mt-0">
                <li>
                  Web Service API-based access to the complete platform and
                  engine supports custom UI development, centralized management
                  of rules, labels, messages, and data, and service/API access
                  for large travel corporations that need flexible enterprise
                  interfaces
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <ul className="mt-0">
                <li>
                  Our services architecture allows engines and modules to plug
                  into existing travel technology infrastructure, protecting
                  technology investments while supporting phased modernization
                </li>
                <li>
                  UI modules, payment flows, reporting, supplier services, and
                  operational workflows can be extended as custom modules around
                  the systems enterprise travel companies already use
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center">
          <img
            src={SaasModel}
            className="w-100"
            style={{ maxWidth: "1199px" }}
            alt="TravelCarma enterprise SaaS delivery model diagram"
          />
        </div>
        <div className="text-center">
          <h2 className="mt-4 text-center mb-5">Client Case Studies</h2>
          <p className="text-center">
            Here are a few examples of how TravelCarma has helped its clients
            achieve their business goals
          </p>
          <Link to="/case-studies" className="btn btn-primary mt-3">
            Read Client Case Studies
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SolutionsEnterpriseSoftware;
